const IconNextPlain = props => (
	<svg width={40} height={40} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M16 27V13l8 7-8 7Z" fill="currentColor" />
	</svg>
);

export default IconNextPlain;
